import axios from 'axios';

export async function getCitysCourts(city_pk) {
  try {
    const res = await axios({
      method: 'GET',
      url:
        process.env.REACT_APP_API_URL +
        `/api/configuration/cities/${city_pk}/courts/`,
    });
    return res.data;
  } catch (error) {
    return { error: error };
  }
}

